/** A share as a whole percentage, such as 0.825 as "83%". */
export function formatPercent(share: number): string {
  return `${Math.round(share * 100)}%`
}

/** The word for a count: "1 check", "2 checks". Only regular plurals. */
export function plural(count: number, word: string): string {
  return count === 1 ? word : `${word}s`
}
